import { useCallback } from 'react';

import { useUpdatePatient } from '@helpful/network';
import { useUser } from '@core/user';
import { usePatient } from '@common/hooks';

import { PlanForm } from '../Connect.types';

import { DetailsForm } from './Details.types';

type UseDetailsReturnType = [
  {
    isSuccess: boolean;
    isLoading: boolean;
    defaultValues: DetailsForm;
  },
  (form: DetailsForm) => Promise<string>
];

export const useDetails = ({
  zip,
  fips,
  plans = [],
  plan = null,
  supplemental = null,
  supplementals = [],
}: PlanForm): UseDetailsReturnType => {
  const [, refetch] = useUser();
  const [{ patient }] = usePatient();

  const {
    isSuccess,
    isLoading,
    mutateAsync: updatePatient,
  } = useUpdatePatient();

  const defaultValues: DetailsForm = {
    firstName: patient.firstName,
    lastName: patient.lastName,
    zip: `${zip}`,
    fips: `${fips}`,
  };

  const dispatch = useCallback(
    async (form: DetailsForm) => {
      const { data } = await updatePatient({
        id: patient.id,
        data: {
          plans: [plan, supplemental, ...plans, ...supplementals]
            .filter((id) => !!id)
            .map((id) => ({ id })),
          ...form,
        },
      });
      refetch();
      return data?.id;
    },
    [updatePatient, patient, refetch, plan, plans, supplemental, supplementals]
  );

  return [{ isSuccess, isLoading, defaultValues }, dispatch];
};
